import {
  BodyHeavy,
  BodyLight,
  CaptionHeavy,
  CaptionLight,
  Colors,
  Icon,
  MediaQuery,
  Skeleton,
  Theme,
} from '@pelando/components';
import styled, { css } from 'styled-components';

const storeTabsContainerStyles = css`
  margin-bottom: 40px;
  grid-area: tabs;

  @media ${MediaQuery.SCREEN_MD_UP} {
    margin-bottom: 48px;
  }
`;

export const StoreTabsContainer = styled.div`
  ${storeTabsContainerStyles}
`;

export const StoreTabsHeader = styled.div`
  display: flex;
  column-gap: 8px;
  padding: 0 16px;

  a {
    display: contents;
  }

  @media ${MediaQuery.SCREEN_MD_UP} {
    padding: 0;
  }
`;

export const StoreTabsContentSkeleton = styled.div`
  height: 100%;
  display: flex;
  margin-top: 16px;
  justify-content: center;
`;

export const StoreTabsContent = styled.div`
  height: 100%;
  display: flex;
  margin-top: 16px;
  justify-content: center;
`;

export const TabIcon = styled(Icon)`
  font-size: 24px;
  margin-right: 4px;
`;

export const Tab = styled.div`
  min-width: 120px;
  ${CaptionLight}
  padding: 8px 16px;
  border-radius: 12px;
  display: inline-flex;
  align-items: center;
  height: 40px;
  justify-content: center;
  color: rgb(${Theme.colors.Alpha});

  i {
    font-size: 24px;
    margin-right: 4px;
    margin-left: -8px;
    color: rgb(${Colors.Gray});
  }

  &:hover {
    background-color: rgb(${Theme.colors.India});

    i {
      color: rgb(${Theme.colors.Brand});
    }
  }

  &[data-selected='true'] {
    ${CaptionHeavy}
    background-color: rgb(${Theme.colors.Bravo});

    i {
      color: rgb(${Theme.colors.Brand});
    }

    @media ${MediaQuery.SCREEN_MD_UP} {
      ${BodyHeavy}
    }
  }

  @media ${MediaQuery.SCREEN_MD_UP} {
    ${BodyLight}
  }
`;

export const TabButtonSkeleton = styled(Skeleton)`
  border-radius: 12px;
  max-width: 161px;
  height: 40px;
`;

export const StoreTabsSkeletonContainer = styled.div`
  ${storeTabsContainerStyles}
`;

export const TabContentWrapper = styled.div`
  display: contents;
`;
